import api from '../api';

/**
 * Service for handling messaging between providers and groups
 */
export const messageService = {
  /**
   * Fetch all conversations for the current user
   * @returns {Promise} Promise with list of conversations
   */
  getConversations: async () => {
    try {
      const response = await api.get('/messages/conversations');
      return response.data || [];
    } catch (error) {
      console.error('Error fetching conversations:', error);
      throw error;
    }
  },

  /**
   * Fetch messages for a specific conversation
   * @param {string} conversationId - conversation identifier
   * @returns {Promise} Promise with list of messages
   */
  getMessages: async (conversationId) => {
    try {
      const response = await api.get(`/messages/conversations/${conversationId}`);
      return response.data || [];
    } catch (error) {
      console.error('Error fetching messages:', error);
      throw error;
    }
  },

  /**
   * Send a new message in a conversation
   * @param {string} conversationId - conversation identifier
   * @param {string} content - message text
   * @returns {Promise} Promise with created message
   */
  sendMessage: async (conversationId, content) => {
    try {
      const response = await api.post(`/messages/conversations/${conversationId}`, { content });
      return response.data;
    } catch (error) {
      console.error('Error sending message:', error);
      throw error;
    }
  }
};

export default messageService;
